/**
 * GENERATED by `apps/start/scripts/generate-funnel-demo-audio.ts` — do not edit.
 *
 * Word timestamps (ms, relative to clip start) for the funnel reader demo,
 * produced by the same Kokoro call that produced the mp3s in
 * `public/funnel-demo/`. Indices are positional against `demoWords(variant)`.
 */
import { Schema } from 'effect';
import type { DemoVariant, DemoVoiceKey } from './demo-script';

export const DemoClip = Schema.Struct({
  src: Schema.String,
  words: Schema.Array(
    Schema.Struct({
      start: Schema.Finite,
      end: Schema.Finite,
    }),
  ),
});
export type DemoClip = typeof DemoClip.Type;

export const DEMO_AUDIO = new Map<
  DemoVariant,
  ReadonlyMap<DemoVoiceKey, DemoClip>
>([
  [
    'research',
    new Map([
      [
        'Scarlett',
        {
          src: '/funnel-demo/research-scarlett.mp3',
          words: [
            { start: 250, end: 800 },
            { start: 800, end: 1338 },
            { start: 1338, end: 1875 },
            { start: 1875, end: 2025 },
            { start: 2025, end: 2375 },
            { start: 2375, end: 2575 },
            { start: 2575, end: 3075 },
            { start: 3075, end: 3675 },
            { start: 3675, end: 3938 },
            { start: 3938, end: 4400 },
            { start: 4400, end: 4525 },
            { start: 4525, end: 5000 },
            { start: 5000, end: 6175 },
            { start: 6175, end: 6438 },
            { start: 6438, end: 7400 },
            { start: 7400, end: 7650 },
            { start: 7650, end: 7813 },
            { start: 7813, end: 8150 },
            { start: 8150, end: 9013 },
            { start: 9013, end: 9550 },
            { start: 9550, end: 9725 },
            { start: 9725, end: 9888 },
            { start: 9888, end: 10275 },
            { start: 10275, end: 10875 },
            { start: 10875, end: 11125 },
            { start: 11125, end: 11925 },
          ],
        },
      ],
      [
        'Hugh',
        {
          src: '/funnel-demo/research-hugh.mp3',
          words: [
            { start: 325, end: 813 },
            { start: 813, end: 1288 },
            { start: 1288, end: 1750 },
            { start: 1750, end: 1900 },
            { start: 1900, end: 2275 },
            { start: 2275, end: 2475 },
            { start: 2475, end: 3038 },
            { start: 3038, end: 3463 },
            { start: 3463, end: 3713 },
            { start: 3713, end: 4425 },
            { start: 4425, end: 4575 },
            { start: 4575, end: 5188 },
            { start: 5188, end: 6313 },
            { start: 6313, end: 6550 },
            { start: 6550, end: 7525 },
            { start: 7525, end: 7775 },
            { start: 7775, end: 7938 },
            { start: 7938, end: 8250 },
            { start: 8250, end: 9163 },
            { start: 9163, end: 9775 },
            { start: 9775, end: 9975 },
            { start: 9975, end: 10113 },
            { start: 10113, end: 10450 },
            { start: 10450, end: 11100 },
            { start: 11100, end: 11350 },
            { start: 11350, end: 12325 },
          ],
        },
      ],
      [
        'Amy',
        {
          src: '/funnel-demo/research-amy.mp3',
          words: [
            { start: 225, end: 700 },
            { start: 700, end: 1025 },
            { start: 1025, end: 1450 },
            { start: 1450, end: 1575 },
            { start: 1575, end: 1900 },
            { start: 1900, end: 2100 },
            { start: 2100, end: 2625 },
            { start: 2625, end: 3000 },
            { start: 3000, end: 3225 },
            { start: 3225, end: 3675 },
            { start: 3675, end: 3800 },
            { start: 3800, end: 4300 },
            { start: 4300, end: 5488 },
            { start: 5488, end: 5713 },
            { start: 5713, end: 6525 },
            { start: 6525, end: 6738 },
            { start: 6738, end: 6875 },
            { start: 6875, end: 7100 },
            { start: 7100, end: 7975 },
            { start: 7975, end: 8500 },
            { start: 8500, end: 8675 },
            { start: 8675, end: 8800 },
            { start: 8800, end: 9125 },
            { start: 9125, end: 9638 },
            { start: 9638, end: 9875 },
            { start: 9875, end: 10950 },
          ],
        },
      ],
      [
        'Justin',
        {
          src: '/funnel-demo/research-justin.mp3',
          words: [
            { start: 225, end: 713 },
            { start: 713, end: 1138 },
            { start: 1138, end: 1675 },
            { start: 1675, end: 1825 },
            { start: 1825, end: 2200 },
            { start: 2200, end: 2400 },
            { start: 2400, end: 3013 },
            { start: 3013, end: 3438 },
            { start: 3438, end: 3688 },
            { start: 3688, end: 4388 },
            { start: 4388, end: 4550 },
            { start: 4550, end: 5163 },
            { start: 5163, end: 6275 },
            { start: 6275, end: 6500 },
            { start: 6500, end: 7525 },
            { start: 7525, end: 7775 },
            { start: 7775, end: 7925 },
            { start: 7925, end: 8200 },
            { start: 8200, end: 9113 },
            { start: 9113, end: 9725 },
            { start: 9725, end: 9900 },
            { start: 9900, end: 10025 },
            { start: 10025, end: 10350 },
            { start: 10350, end: 11113 },
            { start: 11113, end: 11400 },
            { start: 11400, end: 12300 },
          ],
        },
      ],
    ]),
  ],
  [
    'general',
    new Map([
      [
        'Scarlett',
        {
          src: '/funnel-demo/general-scarlett.mp3',
          words: [
            { start: 300, end: 600 },
            { start: 600, end: 950 },
            { start: 950, end: 1150 },
            { start: 1150, end: 1338 },
            { start: 1338, end: 1400 },
            { start: 1400, end: 1700 },
            { start: 1700, end: 2525 },
            { start: 2525, end: 2650 },
            { start: 2650, end: 2813 },
            { start: 2813, end: 2875 },
            { start: 2875, end: 3200 },
            { start: 3200, end: 4250 },
            { start: 4250, end: 4763 },
            { start: 4763, end: 5088 },
            { start: 5088, end: 5200 },
            { start: 5200, end: 5500 },
            { start: 5500, end: 5850 },
            { start: 5850, end: 6100 },
            { start: 6100, end: 6375 },
            { start: 6375, end: 6475 },
            { start: 6475, end: 6675 },
            { start: 6675, end: 6975 },
            { start: 6975, end: 7175 },
            { start: 7175, end: 7338 },
            { start: 7338, end: 7900 },
            { start: 7900, end: 8625 },
            { start: 8625, end: 8788 },
            { start: 8788, end: 9050 },
            { start: 9050, end: 9800 },
          ],
        },
      ],
      [
        'Hugh',
        {
          src: '/funnel-demo/general-hugh.mp3',
          words: [
            { start: 400, end: 700 },
            { start: 700, end: 1050 },
            { start: 1050, end: 1275 },
            { start: 1275, end: 1438 },
            { start: 1438, end: 1525 },
            { start: 1525, end: 1875 },
            { start: 1875, end: 2650 },
            { start: 2650, end: 2775 },
            { start: 2775, end: 2938 },
            { start: 2938, end: 3038 },
            { start: 3038, end: 3425 },
            { start: 3425, end: 4400 },
            { start: 4400, end: 4863 },
            { start: 4863, end: 5325 },
            { start: 5325, end: 5525 },
            { start: 5525, end: 5875 },
            { start: 5875, end: 6350 },
            { start: 6350, end: 6575 },
            { start: 6575, end: 6975 },
            { start: 6975, end: 7100 },
            { start: 7100, end: 7313 },
            { start: 7313, end: 7600 },
            { start: 7600, end: 7800 },
            { start: 7800, end: 7975 },
            { start: 7975, end: 8588 },
            { start: 8588, end: 9363 },
            { start: 9363, end: 9550 },
            { start: 9550, end: 9888 },
            { start: 9888, end: 10775 },
          ],
        },
      ],
      [
        'Amy',
        {
          src: '/funnel-demo/general-amy.mp3',
          words: [
            { start: 275, end: 500 },
            { start: 500, end: 850 },
            { start: 850, end: 1100 },
            { start: 1100, end: 1263 },
            { start: 1263, end: 1325 },
            { start: 1325, end: 1650 },
            { start: 1650, end: 2525 },
            { start: 2525, end: 2650 },
            { start: 2650, end: 2813 },
            { start: 2813, end: 2875 },
            { start: 2875, end: 3200 },
            { start: 3200, end: 4263 },
            { start: 4263, end: 4675 },
            { start: 4675, end: 5013 },
            { start: 5013, end: 5125 },
            { start: 5125, end: 5450 },
            { start: 5450, end: 5688 },
            { start: 5688, end: 5900 },
            { start: 5900, end: 6263 },
            { start: 6263, end: 6375 },
            { start: 6375, end: 6575 },
            { start: 6575, end: 6825 },
            { start: 6825, end: 7025 },
            { start: 7025, end: 7188 },
            { start: 7188, end: 7625 },
            { start: 7625, end: 8100 },
            { start: 8100, end: 8250 },
            { start: 8250, end: 8475 },
            { start: 8475, end: 9450 },
          ],
        },
      ],
      [
        'Justin',
        {
          src: '/funnel-demo/general-justin.mp3',
          words: [
            { start: 250, end: 550 },
            { start: 550, end: 900 },
            { start: 900, end: 1150 },
            { start: 1150, end: 1313 },
            { start: 1313, end: 1375 },
            { start: 1375, end: 1725 },
            { start: 1725, end: 2550 },
            { start: 2550, end: 2675 },
            { start: 2675, end: 2838 },
            { start: 2838, end: 2938 },
            { start: 2938, end: 3325 },
            { start: 3325, end: 4213 },
            { start: 4213, end: 4688 },
            { start: 4688, end: 5150 },
            { start: 5150, end: 5350 },
            { start: 5350, end: 5700 },
            { start: 5700, end: 6238 },
            { start: 6238, end: 6513 },
            { start: 6513, end: 6925 },
            { start: 6925, end: 7050 },
            { start: 7050, end: 7263 },
            { start: 7263, end: 7625 },
            { start: 7625, end: 7825 },
            { start: 7825, end: 7988 },
            { start: 7988, end: 8575 },
            { start: 8575, end: 9338 },
            { start: 9338, end: 9513 },
            { start: 9513, end: 9788 },
            { start: 9788, end: 10600 },
          ],
        },
      ],
    ]),
  ],
]);

export function demoClip(variant: DemoVariant, voice: DemoVoiceKey) {
  const clip = DEMO_AUDIO.get(variant)?.get(voice);
  if (!clip) throw new Error(`Missing funnel demo clip: ${variant}/${voice}`);
  return clip;
}
